<template>
  <div>
    <AppHeaderDropdown right no-caret>
      <template slot="header">
        <b-avatar :src="user.picture"
                  :alt="user.name"
                  v-b-tooltip.hover.lefttop :title="nameUser"
                  v-if="user.picture">
        </b-avatar>
        <b-avatar v-else
                  :icon="user.icon"
                  :alt="user.name"
                  variant="dark"
                  v-b-tooltip.hover.lefttop :title="user.name + ' - ' + user.email">
        </b-avatar>
      </template>
      <template slot="dropdown">
        <b-dropdown-item v-on:click="clearCache">
          <b-icon icon="eraser-fill"></b-icon> Limpiar Cache
        </b-dropdown-item>
        <b-dropdown-item v-on:click="openChangePassword">
          <b-icon icon="key-fill"></b-icon> Cambiar Contraseña
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item v-on:click="logout">
          <b-icon icon="lock"></b-icon> Logout
        </b-dropdown-item>
      </template>
    </AppHeaderDropdown>

    <b-modal v-model="modal.changePassword.active"
             title="Cambiar Contraseña"
             header-bg-variant="dark"
             header-text-variant="white"
             size="md"
             no-close-on-backdrop>
      <b-alert show variant="warning">
        <b-icon icon="exclamation-triangle-fill"></b-icon>
         Al guardar se cerrará la sesión. Deberás volver a ingresar con la nueva contraseña.
      </b-alert>
      <b-row>
        <b-col md="12">
          <b-form-group label="Contraseña Nueva">
            <b-input-group>
              <b-form-input v-model="form.pass_new"
                            :type="showPass.new ? 'text' : 'password'"
                            placeholder="Mínimo 6 caracteres">
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary" @click="showPass.new = !showPass.new">
                  <b-icon :icon="showPass.new ? 'eye-slash' : 'eye'"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button variant="outline-secondary" @click="modal.changePassword.active = false">Cancelar</b-button>
        <b-button variant="dark" @click="saveChangePassword">Guardar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import serviceAPI from './services'
import Session from '@/handler/session'
import {EventBus} from '@/handler/event-bus'
import Error from '@/handler/error'
import Perfil from '@/config/profiles'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown,
  },
  props: {
    loginComo: [Object, Array],
  },
  data: () => {
    return {
      user : {
        name : '',
        picture : '',
        icon: '',
        email : '',
      },
      modal: {
        changePassword: {
          active: false,
        }
      },
      form: {
        pass_new: '',
      },
      showPass: {
        new: false,
      },
    }
  },
  created () {
    EventBus.$on('Auth:auth', data => {
      this.setup()
    })
  },
  mounted() {
    this.setup()
  },
  computed: {
    nameUser() {
      var name = this.user.name + ' - ' + this.user.email
      var subprofile = ''
      if(this.loginComo) {
        if(this.loginComo.subProfile) {
          this.loginComo.subProfile.forEach(element => {
            subprofile = subprofile + element + ","
          });
        }
        if(subprofile) {
          return this.loginComo.profile + ' - (' + subprofile.slice(0, -1) + ') - ' + name
        } else {
          return this.loginComo.profile + ' - ' + name
        }

      } else {
        return name
      }
    }
  },
  methods: {
    setup () {
      if(Session.getSession().auth) {
        var profile_id = Session.getSession().auth.user.profile_id
        var selector_session = Session.getSession().auth.user.selector_session

        if( profile_id == Perfil.PERSONAL) {
          var result = serviceAPI.showStaff(selector_session)

          result.then((response) => {
            this.user.picture = response.data.image
            this.user.icon = 'person-fill'
          })
        }

        if(profile_id == Perfil.CLIENTE) {
          var result = serviceAPI.showCustomers(selector_session)

          result.then((response) => {
            this.user.picture = response.data.image
            this.user.icon = 'building'
          })
        }

        if(profile_id == Perfil.PROVEEDOR) {
          var result = serviceAPI.showSuppliers(selector_session)

          result.then((response) => {
            this.user.picture = response.data.image
            this.user.icon = 'building'
          })
        }

        this.user.name = Session.getSession().auth.user.name
        this.user.email = Session.getSession().auth.user.email
      }
    },
    logout () {
      Session.removeSessionAuth()
    },

    // CAMBIAR CONTRASEÑA
    openChangePassword() {
      this.form.pass_new = ''
      this.showPass.new = false
      this.modal.changePassword.active = true
    },
    saveChangePassword() {
      var result = serviceAPI.changePassword(this.form)

      result.then(() => {
        this.modal.changePassword.active = false
        Session.removeSessionAuth()
      })
      .catch(error => {
        this.$bvToast.toast(Error.showError(error), {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      })
    },

    // CACHE
    clearCache() {
      this.$router.push({ name: 'Clear'}).catch(err => {

          // Ignore the vuex err regarding  navigating to the page they are already on.
          if ( err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')) {

          // But print any other errors to the console
              logError(err);
          }
      });
    },
  },
}
</script>

<style scoped>
::v-deep .dropdown-menu {
  min-width: 180px;
}
</style>
